import * as Yup from "yup";

export interface QuoteFormValues {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  services: string[];
  message: string;
}

export const initialValues: QuoteFormValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  services: [],
  message: "",
};

const tlds = ["com", "org", "net", "in", "io", "app", "co"];
const tldRegex = new RegExp(
  `^[^\\s@]+@[^\\s@]+\\.(${tlds.join("|")})(\\.[A-Za-z]{2,})?$`,
  "i"
);

export const validationSchema = Yup.object({
  firstName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Only alphabets and spaces allowed")
    .max(50, "First name must be at most 50 characters")
    .required("First name is required"),
  lastName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Only alphabets and spaces allowed")
    .max(50, "Last name must be at most 50 characters")
    .required("Last name is required"),
    email: Yup.string()
    .email("Invalid email address")
    .required("Email is required")
    .max(150, "Email must be at most 150 characters")
    .matches(tldRegex, "Invalid email address"),
  phoneNumber: Yup.string()
    .matches(/^\d+$/, "Only numbers allowed")
    .min(10, "Phone number must be at least 10 digits")
    .required("Phone number is required"),
  services: Yup.array().min(1, "At least one service is required"),
  message: Yup.string(),
});

export const enforceEmailPartLimits = (value: string) => {
  const at = value.indexOf("@");
  if (at === -1) {
    return value.slice(0, 64);
  }
  const local = value.slice(0, at).slice(0, 64);
  const domainRaw = value.slice(at + 1);
  const hasTrailingDot = domainRaw.endsWith(".");

  const splitParts = domainRaw.split(".");
  const parts = splitParts.filter(p => p.length > 0).slice(0, 2);

  let domain = parts.join(".");

  if (domain.length > 63) {
    if (parts.length <= 1) {
      domain = domain.slice(0, 63);
    } else {
      let [first, second] = parts;
      const maxAvailable = 63 - 1;
      if (first.length >= maxAvailable) {
        first = first.slice(0, maxAvailable);
        domain = first;
      } else {
        const maxSecond = maxAvailable - first.length;
        second = second.slice(0, maxSecond);
        domain = second ? `${first}.${second}` : first;
      }
    }
  }

  if (hasTrailingDot && parts.length < 2 && domain.length < 63) {
    domain += ".";
  }

  return `${local}@${domain}`;
};
